export const DocumentTypeFlags = {
  Document: 1,
  UserDocument: 2,
  Supplier: 4,
};
